var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"change-password"},[_c('TitleBreadcrumb'),_c('div',{staticClass:"content-base container"},[_c('a-row',{attrs:{"type":"flex","justify":"center"}},[_c('a-col',{attrs:{"md":10}},[_c('ChangePasswordForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }